(() => {
  const mountSelector = '[data-bulk-purchase-2-0-noop-mount]';
  const initializedAttr = 'data-bulk-purchase-2-0-initialized';
  const statusAttr = 'data-bulk-purchase-2-0-status';
  const sizeOrder = ['XS', 'S', 'M', 'L', 'XL'];
  const firstOptionCompactLimit = 8;

  // codex-bp20-i18n-v1: shared PDP bulk-purchase labels are localized by common module, not per product.
  const bp20Translations = {
    en: {
      optionFallback: 'Option', specification: 'Specification', size: 'Size', color: 'Color', availability: 'Availability', price: 'Price', quantity: 'Quantity',
      bulkQuantitySelector: 'Bulk quantity selector', bulkQuantity: 'Bulk quantity', chooseSpecification: 'Choose a specification, then use + / - to enter quantities below.',
      available: 'Available', unavailable: 'Unavailable', selectedOption: 'Selected {option}: {value}',
      decreaseQuantityFor: 'Decrease quantity for {value}', quantityFor: 'Quantity for {value}', increaseQuantityFor: 'Increase quantity for {value}',
      adding: 'Adding...', addMoreReachMoq: 'Add {remaining} more to reach MOQ', addUnitsToCart: 'Add {units} to cart', addSelectedToCart: 'Add selected to cart',
      minimumOrder: 'Minimum order: {moq} {unit}', selectedOfMoq: 'Selected {units} of {moq} {unit}. Add {remaining} more. Estimated total: {total}.', readySelected: 'Ready: {units} {unit} selected. Estimated total: {total}.',
      selectedSpecifications: 'Selected specifications', remove: 'Remove', removeItem: 'Remove {value}', estimatedTotal: 'Estimated total: {total}', clearSelected: 'Clear selected',
      chooseQuantitiesFirst: 'Choose quantities first.', minimumOrderAddMore: 'Minimum order is {moq} {unit}. Add {remaining} more {remainingUnit}.', addedToCart: 'Added {units} {unit} to cart.', unableToAddSelectedItems: 'Unable to add selected items.',
      selectedBelowMoqSummary: 'Selected {units} units. Minimum order: {moq} {unit}. Add {remaining} more {remainingUnit} to meet it.', selectedAcrossSummary: 'Selected {units} units across {lines} specifications.{minimum}', selectedZeroSummary: 'Selected 0 units.{minimum}', minimumOrderSuffix: ' Minimum order: {moq} {unit}',
      unit: 'unit', units: 'units', piece: 'piece', pieces: 'pieces'
    },
    ko: {
      optionFallback: '옵션', specification: '옵션', size: '사이즈', color: '색상', availability: '재고', price: '가격', quantity: '수량',
      bulkQuantitySelector: '대량 수량 선택기', bulkQuantity: '대량 수량', chooseSpecification: '옵션을 선택한 뒤 아래에서 + / - 버튼으로 수량을 입력하세요.',
      available: '구매 가능', unavailable: '품절', selectedOption: '선택한 {option}: {value}',
      decreaseQuantityFor: '{value} 수량 줄이기', quantityFor: '{value} 수량', increaseQuantityFor: '{value} 수량 늘리기',
      adding: '추가 중...', addMoreReachMoq: 'MOQ까지 {remaining}개 더 추가', addUnitsToCart: '{units}개 장바구니 담기', addSelectedToCart: '선택 항목 장바구니 담기',
      minimumOrder: '최소 주문: {moq}{unit}', selectedOfMoq: '{moq}{unit} 중 {units}{unit} 선택됨. {remaining}{remainingUnit} 더 추가하세요. 예상 합계: {total}.', readySelected: '준비 완료: {units}{unit} 선택됨. 예상 합계: {total}.',
      selectedSpecifications: '선택한 옵션', remove: '삭제', removeItem: '{value} 삭제', estimatedTotal: '예상 합계: {total}', clearSelected: '선택 항목 지우기',
      chooseQuantitiesFirst: '먼저 수량을 선택해 주세요.', minimumOrderAddMore: '최소 주문은 {moq}{unit}입니다. {remaining}{remainingUnit} 더 추가해 주세요.', addedToCart: '{units}{unit}를 장바구니에 추가했습니다.', unableToAddSelectedItems: '선택한 항목을 추가할 수 없습니다.',
      selectedBelowMoqSummary: '{units}{unit} 선택됨. 최소 주문: {moq}{unit}. 조건 충족까지 {remaining}{remainingUnit} 더 추가하세요.', selectedAcrossSummary: '{lines}개 옵션에서 총 {units}{unit} 선택됨.{minimum}', selectedZeroSummary: '선택한 수량 0개.{minimum}', minimumOrderSuffix: ' 최소 주문: {moq}{unit}',
      unit: '개', units: '개', piece: '개', pieces: '개'
    },
    fr: {
      optionFallback: 'Option', specification: 'Spécification', size: 'Taille', color: 'Couleur', availability: 'Disponibilité', price: 'Prix', quantity: 'Quantité',
      bulkQuantitySelector: 'Sélecteur de quantité en gros', bulkQuantity: 'Quantité en gros', chooseSpecification: 'Choisissez une spécification, puis utilisez + / - pour saisir les quantités ci-dessous.',
      available: 'Disponible', unavailable: 'Indisponible', selectedOption: '{option} sélectionnée : {value}',
      decreaseQuantityFor: 'Diminuer la quantité pour {value}', quantityFor: 'Quantité pour {value}', increaseQuantityFor: 'Augmenter la quantité pour {value}',
      adding: 'Ajout...', addMoreReachMoq: 'Ajouter encore {remaining} pour atteindre le MOQ', addUnitsToCart: 'Ajouter {units} au panier', addSelectedToCart: 'Ajouter la sélection au panier',
      minimumOrder: 'Commande minimum : {moq} {unit}', selectedOfMoq: '{units} sur {moq} {unit} sélectionnés. Ajoutez encore {remaining}. Total estimé : {total}.', readySelected: 'Prêt : {units} {unit} sélectionnés. Total estimé : {total}.',
      selectedSpecifications: 'Spécifications sélectionnées', remove: 'Retirer', removeItem: 'Retirer {value}', estimatedTotal: 'Total estimé : {total}', clearSelected: 'Effacer la sélection',
      chooseQuantitiesFirst: 'Choisissez d’abord les quantités.', minimumOrderAddMore: 'La commande minimum est de {moq} {unit}. Ajoutez encore {remaining} {remainingUnit}.', addedToCart: '{units} {unit} ajouté(s) au panier.', unableToAddSelectedItems: 'Impossible d’ajouter les articles sélectionnés.',
      selectedBelowMoqSummary: '{units} unités sélectionnées. Commande minimum : {moq} {unit}. Ajoutez encore {remaining} {remainingUnit} pour l’atteindre.', selectedAcrossSummary: '{units} unités sélectionnées sur {lines} spécifications.{minimum}', selectedZeroSummary: '0 unité sélectionnée.{minimum}', minimumOrderSuffix: ' Commande minimum : {moq} {unit}',
      unit: 'unité', units: 'unités', piece: 'pièce', pieces: 'pièces'
    },
    'zh-TW': {
      optionFallback: '選項', specification: '規格', size: '尺寸', color: '顏色', availability: '供貨狀態', price: '價格', quantity: '數量',
      bulkQuantitySelector: '批量數量選擇器', bulkQuantity: '批量數量', chooseSpecification: '請先選擇規格，然後使用下方 + / - 輸入數量。',
      available: '可購買', unavailable: '缺貨', selectedOption: '已選 {option}: {value}',
      decreaseQuantityFor: '減少 {value} 數量', quantityFor: '{value} 數量', increaseQuantityFor: '增加 {value} 數量',
      adding: '加入中...', addMoreReachMoq: '再加 {remaining} 件以達到 MOQ', addUnitsToCart: '加入 {units} 件到購物車', addSelectedToCart: '將選取項目加入購物車',
      minimumOrder: '最低訂購量: {moq} {unit}', selectedOfMoq: '已選 {units} / {moq} {unit}。再加 {remaining} 件。預估總計: {total}。', readySelected: '已就緒: 已選 {units} {unit}。預估總計: {total}。',
      selectedSpecifications: '已選規格', remove: '移除', removeItem: '移除 {value}', estimatedTotal: '預估總計: {total}', clearSelected: '清除選取',
      chooseQuantitiesFirst: '請先選擇數量。', minimumOrderAddMore: '最低訂購量為 {moq} {unit}。請再加 {remaining} {remainingUnit}。', addedToCart: '已將 {units} {unit}加入購物車。', unableToAddSelectedItems: '無法加入選取項目。',
      selectedBelowMoqSummary: '已選 {units} {unit}。最低訂購量: {moq} {unit}。請再加 {remaining} {remainingUnit}以達標。', selectedAcrossSummary: '已在 {lines} 個規格中選擇 {units} {unit}。{minimum}', selectedZeroSummary: '已選 0 件。{minimum}', minimumOrderSuffix: ' 最低訂購量: {moq} {unit}',
      unit: '件', units: '件', piece: '件', pieces: '件'
    },
    'zh-CN': {
      optionFallback: '选项', specification: '规格', size: '尺寸', color: '颜色', availability: '供货状态', price: '价格', quantity: '数量',
      bulkQuantitySelector: '批量数量选择器', bulkQuantity: '批量数量', chooseSpecification: '请先选择规格，然后使用下方 + / - 输入数量。',
      available: '可购买', unavailable: '缺货', selectedOption: '已选 {option}: {value}',
      decreaseQuantityFor: '减少 {value} 数量', quantityFor: '{value} 数量', increaseQuantityFor: '增加 {value} 数量',
      adding: '加入中...', addMoreReachMoq: '再加 {remaining} 件以达到 MOQ', addUnitsToCart: '加入 {units} 件到购物车', addSelectedToCart: '将选中项加入购物车',
      minimumOrder: '最低订购量: {moq} {unit}', selectedOfMoq: '已选 {units} / {moq} {unit}。再加 {remaining} 件。预估总计: {total}。', readySelected: '已就绪: 已选 {units} {unit}。预估总计: {total}。',
      selectedSpecifications: '已选规格', remove: '移除', removeItem: '移除 {value}', estimatedTotal: '预估总计: {total}', clearSelected: '清除选中项',
      chooseQuantitiesFirst: '请先选择数量。', minimumOrderAddMore: '最低订购量为 {moq} {unit}。请再加 {remaining} {remainingUnit}。', addedToCart: '已将 {units} {unit}加入购物车。', unableToAddSelectedItems: '无法加入选中项。',
      selectedBelowMoqSummary: '已选 {units} {unit}。最低订购量: {moq} {unit}。请再加 {remaining} {remainingUnit}以达标。', selectedAcrossSummary: '已在 {lines} 个规格中选择 {units} {unit}。{minimum}', selectedZeroSummary: '已选 0 件。{minimum}', minimumOrderSuffix: ' 最低订购量: {moq} {unit}',
      unit: '件', units: '件', piece: '件', pieces: '件'
    }
  };

  function bp20Locale() {
    const explicit = clean(window.Shopify?.locale || document.documentElement.lang || '').replace('_', '-');
    const pathLocale = clean((window.location?.pathname || '').split('/').filter(Boolean)[0]).replace('_', '-');
    const raw = (pathLocale || explicit || 'en').toLowerCase();
    if (raw === 'ko' || raw.startsWith('ko-')) return 'ko';
    if (raw === 'fr' || raw.startsWith('fr-')) return 'fr';
    if (raw === 'zh-tw' || raw === 'zh-hant' || raw.startsWith('zh-tw-')) return 'zh-TW';
    if (raw === 'zh-cn' || raw === 'zh-hans' || raw === 'zh' || raw.startsWith('zh-cn-')) return 'zh-CN';
    return 'en';
  }

  function bp20T(key, vars = {}) {
    const dict = bp20Translations[bp20Locale()] || bp20Translations.en;
    let text = dict[key] || bp20Translations.en[key] || key;
    Object.entries(vars).forEach(([name, value]) => {
      text = text.split('{' + name + '}').join(String(value));
    });
    return text;
  }

  function bp20Unit(count, singularKey = 'piece', pluralKey = 'pieces') {
    return bp20T(Number(count) === 1 ? singularKey : pluralKey);
  }

  function bp20OptionLabel(label) {
    const value = clean(label);
    const key = {
      option: 'optionFallback',
      options: 'optionFallback',
      specification: 'specification',
      specifications: 'specification',
      spec: 'specification',
      size: 'size',
      color: 'color',
      colour: 'color',
      quantity: 'quantity'
    }[value.toLowerCase()];
    return key ? bp20T(key) : value;
  }

  // bp20 formal replacement 2-10: BP20 is now the primary PDP bulk-purchase entry.
  function markBp20PurchaseReady() {
    retireResidualMultivariants();
    document.body.classList.remove('has-visible-multivariants-purchase');
    hideNativeVariantPicker();
    document.body.classList.add('bp20-purchase-ready');
    document.body.setAttribute('data-bp20-purchase-entry', 'bulk-purchase-2-25');
  }



  // bp20 formal replacement 2-11: retire cached multivariants remnants after app uninstall.
  function retireResidualMultivariants() {
    document.body.classList.remove('has-visible-multivariants-purchase');
    const selectors = [
      '.multivariants_add_to_cart_button',
      '[class*="multivariants" i]',
      '[id*="multivariants" i]',
      '[data-multivariants]',
      '[data-mv-main]',
      '[data-mv-app]',
      '[data-mv-container]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((node) => {
      const container = node.closest('[class*="multivariants" i], [id*="multivariants" i]') || node;
      if (container === document.body || container === document.documentElement) return;
      container.setAttribute('data-bp20-retired-multivariants', 'true');
      container.setAttribute('hidden', '');
      container.style.setProperty('display', 'none', 'important');
    });
  }



  // bp20 formal replacement 2-13: mount outside hidden native variant block once BP20 owns PDP selection.
  function hideNativeVariantPicker() {
    const selectors = [
      '.product__block--variant_picker',
      'variant-radios',
      'variant-selects',
      '[data-product-variant-picker]',
      '[data-block-type="variant_picker"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((node) => {
      if (!node.closest('.product, .product__info-container, [id^="shopify-section-template"]')) return;
      node.setAttribute('data-bp20-retired-native-variant-picker', 'true');
      node.setAttribute('hidden', '');
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function revealMount(mount) {
    mount.hidden = false;
    mount.removeAttribute('hidden');
    mount.setAttribute('aria-hidden', 'false');
    mount.style.removeProperty('display');
    mount.classList.add('bulk-purchase-2-0');
  }

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const unique = (values) => Array.from(new Set(values.map(clean).filter(Boolean)));
  const currencyCode = () => window.Shopify?.currency?.active || window.ShopifyAnalytics?.meta?.currency || 'USD';
  const money = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode() }).format(value / 100);
    } catch {
      return '';
    }
  };

  // bp20 moq parse non5/non30 hotfix 2026-06-07: prefer explicit PDP title/H1 MOQ over broad page tags.
  function tagsFromPageData() {
    const tags = Array.isArray(window.productData?.tags) ? window.productData.tags : [];
    return tags.map(clean).filter(Boolean);
  }

  function canonicalMoq(tags) {
    const values = unique(tags)
      .map((tag) => tag.match(/^moq([1-9]\d*)$/i)?.[1])
      .filter(Boolean)
      .map(Number);
    return values.length === 1 ? values[0] : null;
  }

  function moqFromProductTextValues(values) {
    const candidates = unique(values).flatMap((value) => {
      const text = clean(value);
      if (!text) return [];
      const matches = Array.from(text.matchAll(/\bMOQ\s*(?:=|:)?\s*([1-9]\d{0,2}(?:,\d{3})*|[1-9]\d*)\s*(?:pcs?|pieces?)?\b/gi));
      return matches.map((match) => Number(String(match[1]).replace(/,/g, ''))).filter(Number.isFinite);
    });
    const uniqueValues = unique(candidates.map(String)).map(Number);
    return uniqueValues.length === 1 ? uniqueValues[0] : null;
  }

  function productTitleMoqFallback() {
    const product = window.ShopifyAnalytics?.meta?.product || {};
    const titleNodes = Array.from(document.querySelectorAll('h1.product__title, .product__title h1, h1'))
      .map((node) => node.textContent);
    const variantNames = Array.isArray(product.variants)
      ? product.variants.flatMap((variant) => [variant.name, variant.public_title])
      : [];
    return moqFromProductTextValues([
      product.name,
      product.title,
      document.title,
      ...variantNames,
      ...titleNodes,
    ]);
  }

  function moqFromMount(mount) {
    const value = Number(clean(mount?.getAttribute('data-bp20-moq')));
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  function moqFromVariantOptions(variants) {
    const values = unique(variants.flatMap((variant) => variant.options || [])).flatMap((value) => {
      const match = clean(value).match(/^([1-9]\d*)\s*(?:pcs?|pieces?)$/i);
      return match ? [Number(match[1])] : [];
    });
    const uniqueValues = unique(values.map(String)).map(Number);
    return uniqueValues.length === 1 ? uniqueValues[0] : null;
  }

  function effectiveMoq(variants = [], mount = null) {
    return moqFromMount(mount) || productTitleMoqFallback() || canonicalMoq(tagsFromPageData()) || moqFromVariantOptions(variants);
  }

  function sectionRoot(mount) {
    return mount.closest('[id^="shopify-section-"]') || mount.closest('product-info') || document;
  }

  function normalizeVariant(row) {
    if (!row) return null;
    const options = Array.isArray(row.options)
      ? row.options
      : [row.option1, row.option2, row.option3];
    const normalizedOptions = options.map(clean).filter(Boolean);
    const id = String(row.id || row.variant_id || '');
    if (!id || !normalizedOptions.length) return null;
    const featuredMedia = row.featured_media || row.featuredMedia || {};
    const featuredImage = row.featured_image || row.featuredImage || featuredMedia.preview_image || {};
    return {
      id,
      options: normalizedOptions,
      available: row.available !== false,
      price: row.price,
      sku: row.sku || '',
      featuredMediaId: clean(featuredMedia.id || row.featured_media_id || row.featuredMediaId || ''),
      featuredImageId: clean(featuredImage.id || row.featured_image_id || row.featuredImageId || ''),
      featuredImageSrc: clean(featuredImage.src || featuredImage.url || featuredMedia.preview_image?.src || '')
    };
  }

  function variantsFromFallback() {
    const script = document.querySelector('script[data-mv-variants-fallback]');
    if (!script) return [];
    try {
      const rows = JSON.parse(script.textContent || '[]');
      return rows.map(normalizeVariant).filter(Boolean);
    } catch {
      return [];
    }
  }

  function variantsFromVariantScripts(root) {
    const scripts = Array.from(root.querySelectorAll('variant-selects script[type="application/json"], variant-radios script[type="application/json"], product-info script[type="application/json"]'));
    for (const script of scripts) {
      try {
        const json = JSON.parse(script.textContent || '');
        const rows = Array.isArray(json) ? json : json.variants;
        if (Array.isArray(rows)) {
          const variants = rows.map(normalizeVariant).filter(Boolean);
          if (variants.length) return variants;
        }
      } catch {
        // Try the next script.
      }
    }
    return [];
  }

  function variantsFromAnalytics() {
    const product = window.ShopifyAnalytics?.meta?.product;
    if (!product?.variants?.length) return [];
    return product.variants.map((variant) => {
      const options = Array.isArray(variant.options)
        ? variant.options
        : String(variant.public_title || '').split(' / ');
      return normalizeVariant({
        id: variant.id,
        options,
        available: variant.available !== false,
        price: variant.price,
        sku: variant.sku
      });
    }).filter(Boolean);
  }

  function optionNames(root, variants) {
    const legends = Array.from(root.querySelectorAll('variant-selects fieldset legend, variant-radios fieldset legend'))
      .map((node) => clean(node.textContent).replace(/:$/, ''))
      .filter(Boolean);
    if (legends.length) return legends;
    const maxOptions = variants.reduce((max, variant) => Math.max(max, variant.options.length), 0);
    return Array.from({ length: maxOptions }, (_, index) => 'Option ' + (index + 1));
  }

  function productData(mount) {
    const root = sectionRoot(mount);
    const variants = variantsFromFallback().length
      ? variantsFromFallback()
      : (variantsFromVariantScripts(root).length ? variantsFromVariantScripts(root) : variantsFromAnalytics());
    if (!variants.length) return null;
    return {
      root,
      optionNames: optionNames(root, variants),
      variants,
      moq: effectiveMoq(variants, mount),
    };
  }

  function variantFor(data, firstValue, secondValue) {
    return data.variants.find((variant) => {
      if (variant.options[0] !== firstValue) return false;
      return data.optionNames.length < 2 || variant.options[1] === secondValue;
    });
  }

  function variantForOptions(data, values) {
    return data.variants.find((variant) =>
      values.every((value, index) => variant.options[index] === value)
    ) || null;
  }

  function nativePickerFor(data) {
    const root = data?.root || document;
    return root.querySelector('product-info variant-selects, product-info variant-radios, variant-selects, variant-radios') ||
      document.querySelector('product-info variant-selects, product-info variant-radios, variant-selects, variant-radios');
  }

  function syncNativeOption(data, optionIndex, value) {
    const nativePicker = nativePickerFor(data);
    if (!nativePicker) return false;
    const normalizedValue = clean(value);
    const fieldsets = Array.from(nativePicker.querySelectorAll('fieldset'));
    const fieldset = fieldsets[optionIndex];
    if (fieldset) {
      const input = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
        .find((node) => clean(node.value) === normalizedValue || clean(node.getAttribute('value')) === normalizedValue);
      if (input && !input.disabled) {
        if (!input.checked) input.click();
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    const selects = Array.from(nativePicker.querySelectorAll('select'));
    const select = selects[optionIndex];
    if (select) {
      const option = Array.from(select.options).find((node) => clean(node.value) === normalizedValue || clean(node.textContent) === normalizedValue);
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function syncNativeVariant(data, variant) {
    if (!variant || !Array.isArray(variant.options)) return false;
    let synced = false;
    variant.options.forEach((value, index) => {
      synced = syncNativeOption(data, index, value) || synced;
    });
    syncVariantMedia(data, variant);
    return synced;
  }

  // bp20 variant media sync 2-25: keep BP20 selected cart payload aligned with the current PDP gallery image.
  function escapeAttrValue(value) {
    const text = clean(value);
    if (!text) return '';
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(text);
    return text.replace(/"/g, '\\"');
  }

  function variantMediaIds(variant) {
    return unique([
      variant?.featuredMediaId,
      variant?.featuredImageId,
    ]);
  }

  function mediaGalleryScopes(data) {
    const root = data?.root || document;
    return unique([
      root.querySelector?.('media-gallery'),
      root.closest?.('media-gallery'),
      document.querySelector('media-gallery'),
    ].filter(Boolean));
  }

  function activateGalleryMedia(gallery, mediaId) {
    const escapedId = escapeAttrValue(mediaId);
    if (!gallery || !escapedId) return false;
    const target = gallery.querySelector('[data-media-id="' + escapedId + '"]');
    const thumb = gallery.querySelector('[data-target="' + escapedId + '"], .product__thumbs-item[data-media-id="' + escapedId + '"]');
    if (!target && !thumb) return false;

    const targetSlide = target?.closest?.('.swiper-slide') || target;
    const targetSwiper = targetSlide?.closest?.('.swiper')?.swiper;
    if (targetSwiper && targetSlide) {
      const slides = Array.from(targetSlide.parentElement?.children || []);
      const index = slides.indexOf(targetSlide);
      if (index >= 0) targetSwiper.slideTo(index);
    }

    const thumbSlide = thumb?.closest?.('.swiper-slide') || thumb;
    const thumbSwiper = thumbSlide?.closest?.('.swiper')?.swiper;
    if (thumbSwiper && thumbSlide) {
      const slides = Array.from(thumbSlide.parentElement?.children || []);
      const index = slides.indexOf(thumbSlide);
      if (index >= 0) thumbSwiper.slideTo(index);
    }

    const thumbTarget = thumb?.querySelector?.('button, a, .product__thumbs-container') || thumb;
    if (thumbTarget && typeof thumbTarget.click === 'function') thumbTarget.click();
    if (targetSlide?.scrollIntoView) targetSlide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    gallery.setAttribute('data-bp20-active-media-id', clean(mediaId));
    gallery.setAttribute('data-bp20-variant-media-sync', '2-25');
    return true;
  }

  function syncVariantMedia(data, variant) {
    const mediaIds = variantMediaIds(variant);
    if (!mediaIds.length) return false;
    for (const gallery of mediaGalleryScopes(data)) {
      for (const mediaId of mediaIds) {
        if (activateGalleryMedia(gallery, mediaId)) return true;
      }
    }
    return false;
  }

  function firstVariantForFirstValue(data, firstValue) {
    return data.variants.find((variant) => variant.options[0] === firstValue) || null;
  }

  function syncFirstSelectionVariant(data, firstValue) {
    const variant = firstVariantForFirstValue(data, firstValue);
    if (variant) return syncNativeVariant(data, variant);
    return syncNativeOption(data, 0, firstValue);
  }

  function pruneQuantitiesForCurrentFirst(data, state) {
    const allowedIds = new Set(
      data.variants
        .filter((variant) => variant.options[0] === state.first)
        .map((variant) => String(variant.id))
    );

    state.quantities.forEach((_, id) => {
      if (!allowedIds.has(String(id))) state.quantities.delete(id);
    });
  }

  function syncUiToSelectedVariant(state, data, fallbackVariant = null) {
    const rows = selectedVariantRows(state, data);
    const variant = rows.length ? rows[rows.length - 1].variant : fallbackVariant;
    if (!variant) return false;
    return syncNativeVariant(data, variant);
  }

  function sortedSecondValues(values) {
    return values.slice().sort((a, b) => {
      const ai = sizeOrder.indexOf(a);
      const bi = sizeOrder.indexOf(b);
      if (ai !== -1 || bi !== -1) return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
      return a.localeCompare(b);
    });
  }

  function optionValuesForPrefix(data, optionIndex, prefixValues) {
    return unique(data.variants
      .filter((variant) => prefixValues.every((value, index) => variant.options[index] === value))
      .map((variant) => variant.options[optionIndex] || '')
      .filter(Boolean));
  }

  function pruneQuantitiesForOptionPrefix(data, state, prefixValues) {
    const allowedIds = new Set(data.variants
      .filter((variant) => prefixValues.every((value, index) => variant.options[index] === value))
      .map((variant) => String(variant.id)));

    state.quantities.forEach((_, id) => {
      if (!allowedIds.has(String(id))) state.quantities.delete(id);
    });
  }

  function ensureThreeOptionState(data, state) {
    const firstValues = optionValuesForPrefix(data, 0, []);
    if (!firstValues.includes(state.first)) state.first = firstValues[0] || '';
    const secondValues = optionValuesForPrefix(data, 1, [state.first]);
    if (!secondValues.includes(state.second)) state.second = secondValues[0] || '';
    return { firstValues, secondValues };
  }

  function textNode(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    element.textContent = text;
    return element;
  }

  function selectControl(labelText, values, selectedValue, onChange) {
    const wrap = document.createElement('div');
    wrap.className = 'bp20-select-control';
    const label = textNode('label', 'bp20-select-label', labelText);
    const select = document.createElement('select');
    select.className = 'bp20-select';
    select.replaceChildren(...values.map((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      return option;
    }));
    select.value = selectedValue || values[0] || '';
    select.addEventListener('change', () => onChange(select.value));
    wrap.append(label, select);
    return wrap;
  }

  function optionDisplayName(data, index, fallback) {
    const raw = clean(data.optionNames[index] || fallback || 'Option');
    if (!raw) return fallback || 'Option';
    return clean(raw.split(':')[0]) || raw;
  }

  function renderMatrix(mount, data, state, parts) {
    const firstLabel = bp20OptionLabel(optionDisplayName(data, 0, bp20T('optionFallback')));
    const secondLabel = bp20OptionLabel(optionDisplayName(data, 1, bp20T('specification')));
    const rows = data.optionNames.length > 1
      ? sortedSecondValues(unique(data.variants.filter((variant) => variant.options[0] === state.first).map((variant) => variant.options[1] || '')))
      : [state.first];

    parts.current.textContent = bp20T('selectedOption', { option: firstLabel, value: state.first });
    const table = document.createElement('table');
    table.className = 'bp20-table';
    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    [bp20T('specification'), bp20T('availability'), bp20T('price'), bp20T('quantity')].forEach((label, index) => {
      const th = document.createElement('th');
      th.textContent = index === 0 ? secondLabel : label;
      headRow.append(th);
    });
    thead.append(headRow);
    const tbody = document.createElement('tbody');

    rows.forEach((value) => {
      const variant = data.optionNames.length > 1
        ? variantFor(data, state.first, value)
        : data.variants.find((row) => row.options[0] === value);
      if (!variant) return;

      const row = document.createElement('tr');
      row.className = 'bp20-row';
      const labelCell = document.createElement('th');
      labelCell.scope = 'row';
      labelCell.className = 'bp20-spec-cell';
      labelCell.textContent = clean(value);
      const availableCell = document.createElement('td');
      availableCell.className = 'bp20-availability-cell';
      availableCell.setAttribute('data-label', bp20T('availability'));
      availableCell.textContent = variant.available ? bp20T('available') : bp20T('unavailable');
      const priceCell = document.createElement('td');
      priceCell.className = 'bp20-price-cell';
      priceCell.setAttribute('data-label', bp20T('price'));
      priceCell.textContent = money(variant.price);
      const quantityCell = document.createElement('td');
      quantityCell.className = 'bp20-quantity-cell';
      quantityCell.setAttribute('data-label', bp20T('quantity'));
      const stepper = document.createElement('div');
      stepper.className = 'bp20-stepper';
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'bp20-stepper-btn';
      minus.textContent = '−';
      minus.setAttribute('aria-label', bp20T('decreaseQuantityFor', { value: clean(value) }));
      const input = document.createElement('input');
      input.className = 'bp20-qty';
      input.type = 'number';
      input.min = '0';
      input.step = '1';
      input.inputMode = 'numeric';
      input.value = String(state.quantities.get(variant.id) || 0);
      input.disabled = !variant.available;
      input.setAttribute('aria-label', bp20T('quantityFor', { value: clean(value) }));
      const plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'bp20-stepper-btn';
      plus.textContent = '+';
      plus.setAttribute('aria-label', bp20T('increaseQuantityFor', { value: clean(value) }));
      const setQuantity = (valueToSet) => {
        const next = Math.max(0, Math.floor(Number(valueToSet) || 0));
        input.value = String(next);
        if (next > 0) state.quantities.set(variant.id, next);
        else state.quantities.delete(variant.id);
        updateUiState(state, parts, data);
        syncUiToSelectedVariant(state, data, variant);
      };
      row.addEventListener('click', (event) => {
        if (event.target.closest('.bp20-stepper-btn, .bp20-qty')) return;
        input.focus();
        if (typeof input.select === 'function') input.select();
      });
      input.addEventListener('input', () => {
        setQuantity(input.value);
      });
      minus.addEventListener('click', () => {
        setQuantity((Number(input.value) || 0) - 1);
      });
      plus.addEventListener('click', () => {
        setQuantity((Number(input.value) || 0) + 1);
      });
      if (!variant.available) {
        minus.disabled = true;
        plus.disabled = true;
      }
      stepper.append(minus, input, plus);
      quantityCell.append(stepper);
      row.append(labelCell, availableCell, priceCell, quantityCell);
      tbody.append(row);
    });

    table.append(thead, tbody);
    parts.matrix.replaceChildren(table);
    updateUiState(state, parts, data);
  }

  function renderThreeOptionMatrix(mount, data, state, parts) {
    const firstLabel = bp20OptionLabel(optionDisplayName(data, 0, bp20T('optionFallback')));
    const secondLabel = bp20OptionLabel(optionDisplayName(data, 1, bp20T('optionFallback')));
    const thirdLabel = bp20OptionLabel(optionDisplayName(data, 2, bp20T('specification')));
    const { firstValues, secondValues } = ensureThreeOptionState(data, state);
    const rows = sortedSecondValues(optionValuesForPrefix(data, 2, [state.first, state.second]));

    const controls = document.createElement('div');
    controls.className = 'bp20-v3-controls';
    controls.setAttribute('data-bp20-option-count', '3');
    controls.append(
      selectControl(firstLabel, firstValues, state.first, (value) => {
        state.first = value;
        state.second = '';
        ensureThreeOptionState(data, state);
        pruneQuantitiesForOptionPrefix(data, state, [state.first, state.second]);
        const nextRows = sortedSecondValues(optionValuesForPrefix(data, 2, [state.first, state.second]));
        syncUiToSelectedVariant(state, data, variantForOptions(data, [state.first, state.second, nextRows[0]]));
        renderThreeOptionMatrix(mount, data, state, parts);
      }),
      selectControl(secondLabel, secondValues, state.second, (value) => {
        state.second = value;
        pruneQuantitiesForOptionPrefix(data, state, [state.first, state.second]);
        const nextRows = sortedSecondValues(optionValuesForPrefix(data, 2, [state.first, state.second]));
        syncUiToSelectedVariant(state, data, variantForOptions(data, [state.first, state.second, nextRows[0]]));
        renderThreeOptionMatrix(mount, data, state, parts);
      })
    );
    parts.control.replaceChildren(controls);
    parts.current.textContent = firstLabel + ': ' + state.first + ' · ' + secondLabel + ': ' + state.second;

    const table = document.createElement('table');
    table.className = 'bp20-table';
    table.setAttribute('data-bp20-mode', 'three-option-table');
    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    [thirdLabel, bp20T('availability'), bp20T('price'), bp20T('quantity')].forEach((label) => {
      const th = document.createElement('th');
      th.textContent = label;
      headRow.append(th);
    });
    thead.append(headRow);
    const tbody = document.createElement('tbody');

    rows.forEach((value) => {
      const variant = variantForOptions(data, [state.first, state.second, value]);
      if (!variant) return;

      const row = document.createElement('tr');
      row.className = 'bp20-row';
      const labelCell = document.createElement('th');
      labelCell.scope = 'row';
      labelCell.className = 'bp20-spec-cell';
      labelCell.textContent = clean(value);
      const availableCell = document.createElement('td');
      availableCell.className = 'bp20-availability-cell';
      availableCell.setAttribute('data-label', bp20T('availability'));
      availableCell.textContent = variant.available ? bp20T('available') : bp20T('unavailable');
      const priceCell = document.createElement('td');
      priceCell.className = 'bp20-price-cell';
      priceCell.setAttribute('data-label', bp20T('price'));
      priceCell.textContent = money(variant.price);
      const quantityCell = document.createElement('td');
      quantityCell.className = 'bp20-quantity-cell';
      quantityCell.setAttribute('data-label', bp20T('quantity'));
      const stepper = document.createElement('div');
      stepper.className = 'bp20-stepper';
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'bp20-stepper-btn';
      minus.textContent = '−';
      minus.setAttribute('aria-label', bp20T('decreaseQuantityFor', { value: clean(value) }));
      const input = document.createElement('input');
      input.className = 'bp20-qty';
      input.type = 'number';
      input.min = '0';
      input.step = '1';
      input.inputMode = 'numeric';
      input.value = String(state.quantities.get(variant.id) || 0);
      input.disabled = !variant.available;
      input.setAttribute('aria-label', bp20T('quantityFor', { value: clean(value) }));
      const plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'bp20-stepper-btn';
      plus.textContent = '+';
      plus.setAttribute('aria-label', bp20T('increaseQuantityFor', { value: clean(value) }));
      const setQuantity = (valueToSet) => {
        const next = Math.max(0, Math.floor(Number(valueToSet) || 0));
        input.value = String(next);
        if (next > 0) state.quantities.set(variant.id, next);
        else state.quantities.delete(variant.id);
        updateUiState(state, parts, data);
        syncUiToSelectedVariant(state, data, variant);
      };
      row.addEventListener('click', (event) => {
        if (event.target.closest('.bp20-stepper-btn, .bp20-qty')) return;
        input.focus();
        if (typeof input.select === 'function') input.select();
      });
      input.addEventListener('input', () => setQuantity(input.value));
      minus.addEventListener('click', () => setQuantity((Number(input.value) || 0) - 1));
      plus.addEventListener('click', () => setQuantity((Number(input.value) || 0) + 1));
      if (!variant.available) {
        minus.disabled = true;
        plus.disabled = true;
      }
      stepper.append(minus, input, plus);
      quantityCell.append(stepper);
      row.append(labelCell, availableCell, priceCell, quantityCell);
      tbody.append(row);
    });

    table.append(thead, tbody);
    parts.matrix.replaceChildren(table);
    updateUiState(state, parts, data);
  }

  function selectedCartItems(state) {
    const items = [];
    state.quantities.forEach((quantity, id) => {
      const safeQuantity = Math.max(0, Math.floor(Number(quantity) || 0));
      if (safeQuantity > 0) items.push({ id, quantity: safeQuantity });
    });
    return items;
  }

  function selectedUnits(state) {
    return selectedCartItems(state).reduce((sum, item) => sum + item.quantity, 0);
  }

  function selectedSubtotalCents(state, data) {
    return selectedVariantRows(state, data).reduce((sum, row) => {
      const price = Number(row.variant.price);
      return Number.isFinite(price) ? sum + (price * row.quantity) : sum;
    }, 0);
  }

  function setStatus(parts, message, status = '') {
    if (!parts?.status) return;
    parts.status.textContent = message || '';
    parts.status.setAttribute('data-bp20-status', status || 'idle');
  }

  function updateActionState(state, parts, data) {
    if (!parts?.addButton) return;
    const units = selectedUnits(state);
    const subtotal = data ? selectedSubtotalCents(state, data) : 0;
    const remaining = data?.moq && units > 0 && units < data.moq ? data.moq - units : 0;
    const belowMoq = Boolean(remaining);
    parts.addButton.disabled = state.pending || units <= 0 || belowMoq;
    parts.addButton.textContent = state.pending
      ? bp20T('adding')
      : (belowMoq ? bp20T('addMoreReachMoq', { remaining }) : (units > 0 ? bp20T('addUnitsToCart', { units }) : bp20T('addSelectedToCart')));
    if (parts.actionMeta) {
      if (!units) {
        parts.actionMeta.textContent = data?.moq ? bp20T('minimumOrder', { moq: data.moq, unit: bp20Unit(data.moq) }) : '';
        parts.actionMeta.setAttribute('data-bp20-action-state', 'empty');
      } else if (belowMoq) {
        parts.actionMeta.textContent = bp20T('selectedOfMoq', { units, moq: data.moq, unit: bp20Unit(data.moq), remaining, remainingUnit: bp20Unit(remaining), total: money(subtotal) });
        parts.actionMeta.setAttribute('data-bp20-action-state', 'below-moq');
      } else {
        parts.actionMeta.textContent = bp20T('readySelected', { units, unit: bp20Unit(units), total: money(subtotal) });
        parts.actionMeta.setAttribute('data-bp20-action-state', 'ready');
      }
    }
  }

  function selectedVariantRows(state, data) {
    const rows = [];
    state.quantities.forEach((quantity, id) => {
      const safeQuantity = Math.max(0, Math.floor(Number(quantity) || 0));
      if (safeQuantity <= 0) return;
      const variant = data.variants.find((row) => String(row.id) === String(id));
      if (variant) rows.push({ variant, quantity: safeQuantity });
    });
    return rows;
  }

  function variantLabel(data, variant) {
    const normalizedOptions = variant.options.map(clean).filter(Boolean);
    return normalizedOptions
      .map((value, index) => {
        const optionName = clean(data.optionNames[index] || '');
        const lowerName = optionName.toLowerCase();
        const lowerValue = value.toLowerCase();
        if (!optionName || lowerName === lowerValue || lowerName.endsWith(': ' + lowerValue)) {
          return value;
        }
        return value;
      })
      .join(' · ');
  }

  function updateSelectedList(state, parts, data) {
    if (!parts?.selectedList) return;
    const rows = selectedVariantRows(state, data);
    if (!rows.length) {
      parts.selectedList.hidden = true;
      parts.selectedList.replaceChildren();
      return;
    }
    parts.selectedList.hidden = false;
    const title = textNode('div', 'bp20-selected-title', bp20T('selectedSpecifications'));
    const list = document.createElement('div');
    list.className = 'bp20-selected-items';
    rows.forEach(({ variant, quantity }) => {
      const item = document.createElement('div');
      item.className = 'bp20-selected-item';
      const label = textNode('span', 'bp20-selected-label', variantLabel(data, variant));
      const qty = textNode('span', 'bp20-selected-qty', 'x ' + quantity);
      const lineTotal = textNode('span', 'bp20-selected-total', money(Number(variant.price) * quantity));
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bp20-selected-remove';
      remove.textContent = bp20T('remove');
      remove.setAttribute('aria-label', bp20T('removeItem', { value: variantLabel(data, variant) }));
      remove.addEventListener('click', () => {
        state.quantities.delete(variant.id);
        renderMatrix(parts.mount, data, state, parts);
      });
      item.append(label, qty, lineTotal, remove);
      list.append(item);
    });
    const total = textNode('div', 'bp20-selected-total-row', bp20T('estimatedTotal', { total: money(selectedSubtotalCents(state, data)) }));
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'bp20-selected-clear';
    clear.textContent = bp20T('clearSelected');
    clear.addEventListener('click', () => {
      state.quantities.clear();
      renderMatrix(parts.mount, data, state, parts);
    });
    parts.selectedList.replaceChildren(title, list, total, clear);
  }

  function updateUiState(state, parts, data) {
    updateSummary(state, parts.summary, data.moq);
    updateSelectedList(state, parts, data);
    updateActionState(state, parts, data);
  }

  function cartAddUrl() {
    const root = window.Shopify?.routes?.root || window.FoxTheme?.routes?.root_url || '/';
    return String(root).replace(/\/$/, '/') + 'cart/add.js';
  }

  function cartSectionsToBundle() {
    const sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
    } catch {}
    return unique(sections);
  }

  async function cartAdd(items) {
    const sections = cartSectionsToBundle();
    const response = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items.map((item) => ({
          id: /^\d+$/.test(String(item.id)) ? Number(item.id) : item.id,
          quantity: item.quantity
        })),
        sections,
        sections_url: window.location.pathname
      })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload.description || payload.message || bp20T('unableToAddSelectedItems'));
    }
    return payload;
  }

  function cartJsonUrl() {
    const cartUrl = window.FoxTheme?.routes?.cart_url || (String(window.Shopify?.routes?.root || '/').replace(/\/$/, '/') + 'cart');
    return String(cartUrl).replace(/\.js$/, '') + '.js';
  }

  let cartDrawerFallbackTimer = 0;

  function openCartDrawerFallbackOnce() {
    window.clearTimeout(cartDrawerFallbackTimer);
    cartDrawerFallbackTimer = window.setTimeout(() => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.show && !drawer.open) drawer.show();
    }, 1200);
  }

  function publishCartUpdate(cart, payload) {
    if (!cart) return false;
    if (payload?.sections) cart.sections = payload.sections;
    const pubsub = window.FoxTheme?.pubsub;
    const eventName = pubsub?.PUB_SUB_EVENTS?.cartUpdate;
    if (pubsub?.publish && eventName && cart.sections) {
      pubsub.publish(eventName, { cart });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'bp20' } }));
    return true;
  }

  function refreshCart(payload) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true, source: 'bp20', payload } }));
    document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: payload } }));
    fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (cart) {
          publishCartUpdate(cart, payload);
        }
      })
      .catch(() => {});
    openCartDrawerFallbackOnce();
  }

  async function handleBulkAdd(mount, data, state, parts) {
    const items = selectedCartItems(state);
    const units = items.reduce((sum, item) => sum + item.quantity, 0);
    if (!units) {
      setStatus(parts, bp20T('chooseQuantitiesFirst'), 'error');
      updateActionState(state, parts, data);
      return;
    }
    if (data.moq && units < data.moq) {
      const remaining = data.moq - units;
      setStatus(parts, bp20T('minimumOrderAddMore', { moq: data.moq, unit: bp20Unit(data.moq), remaining, remainingUnit: bp20Unit(remaining) }), 'error');
      updateActionState(state, parts, data);
      return;
    }
    syncUiToSelectedVariant(state, data, firstVariantForFirstValue(data, state.first));
    state.pending = true;
    setStatus(parts, '', 'loading');
    updateActionState(state, parts, data);
    try {
      const payload = await cartAdd(items);
      state.quantities.clear();
      renderMatrix(mount, data, state, parts);
      setStatus(parts, bp20T('addedToCart', { units, unit: bp20Unit(units, 'unit', 'units') }), 'success');
      refreshCart(payload);
    } catch (error) {
      setStatus(parts, error?.message || bp20T('unableToAddSelectedItems'), 'error');
    } finally {
      state.pending = false;
      updateActionState(state, parts, data);
    }
  }

  function updateSummary(state, summary, moq) {
    let units = 0;
    let lines = 0;
    state.quantities.forEach((quantity) => {
      if (quantity > 0) {
        units += quantity;
        lines += 1;
      }
    });
    if (units > 0 && moq && units < moq) {
      const remaining = moq - units;
      summary.textContent = bp20T('selectedBelowMoqSummary', { units, moq, unit: bp20Unit(moq), remaining, remainingUnit: bp20Unit(remaining) });
      summary.setAttribute('data-bp20-summary-state', 'below-moq');
      return;
    }
    summary.removeAttribute('data-bp20-summary-state');
    summary.textContent = lines
      ? bp20T('selectedAcrossSummary', { units, lines, minimum: moq ? bp20T('minimumOrderSuffix', { moq, unit: bp20Unit(moq) }) : '' })
      : bp20T('selectedZeroSummary', { minimum: moq ? bp20T('minimumOrderSuffix', { moq, unit: bp20Unit(moq) }) : '' });
  }

  function render(mount, data) {
    const firstValues = unique(data.variants.map((variant) => variant.options[0]));
    const optionCount = data.variants.reduce((max, variant) => Math.max(max, variant.options.length), 0);
    if (!firstValues.length || optionCount > 3) {
      mount.hidden = true;
      mount.setAttribute('aria-hidden', 'true');
      mount.setAttribute(statusAttr, optionCount > 3 ? 'unsupported-options' : 'no-variants');
      mount.setAttribute('data-bp20-native-picker-fallback', 'true');
      return false;
    }

    const mode = optionCount === 3
      ? 'three-option-table'
      : (firstValues.length > firstOptionCompactLimit ? 'dropdown-table' : 'compact-grid');
    const state = { first: firstValues[0], second: '', quantities: new Map() };
    revealMount(mount);
    mount.setAttribute(statusAttr, 'visible-matrix-ready');
    markBp20PurchaseReady();
    mount.setAttribute('data-bulk-purchase-2-0-mode', mode);

    const panel = document.createElement('section');
    panel.className = 'bp20-panel';
    panel.setAttribute('aria-label', bp20T('bulkQuantitySelector'));
    const header = document.createElement('div');
    header.className = 'bp20-header';
    header.append(
      textNode('h2', 'bp20-title', bp20T('bulkQuantity')),
      textNode('p', 'bp20-copy', bp20T('chooseSpecification'))
    );
    if (data.moq) {
      header.append(textNode('p', 'bp20-moq', bp20T('minimumOrder', { moq: data.moq, unit: bp20Unit(data.moq) })));
    }
    const control = document.createElement('div');
    control.className = 'bp20-control';
    const current = textNode('div', 'bp20-current', '');
    const matrix = document.createElement('div');
    matrix.className = 'bp20-matrix';
    const summary = textNode('div', 'bp20-summary', bp20T('selectedZeroSummary', { minimum: '' }));
    const selectedList = document.createElement('div');
    selectedList.className = 'bp20-selected-list';
    selectedList.hidden = true;
    const actions = document.createElement('div');
    actions.className = 'bp20-actions';
    const actionMeta = document.createElement('div');
    actionMeta.className = 'bp20-action-meta';
    const addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'bp20-add-button';
    addButton.textContent = bp20T('addSelectedToCart');
    addButton.disabled = true;
    const status = textNode('div', 'bp20-action-status', '');
    status.setAttribute('aria-live', 'polite');
    actions.append(actionMeta, addButton, status);
    panel.append(header, control, current, matrix, summary, selectedList, actions);
    mount.replaceChildren(panel);
    revealMount(mount);

    const parts = { mount, control, current, matrix, summary, selectedList, actions, actionMeta, addButton, status };
    addButton.addEventListener('click', () => handleBulkAdd(mount, data, state, parts));
    const firstLabel = optionDisplayName(data, 0, 'Option');
    if (mode === 'three-option-table') {
      ensureThreeOptionState(data, state);
      syncUiToSelectedVariant(state, data, variantForOptions(data, [
        state.first,
        state.second,
        sortedSecondValues(optionValuesForPrefix(data, 2, [state.first, state.second]))[0]
      ]));
      renderThreeOptionMatrix(mount, data, state, parts);
    } else if (mode === 'dropdown-table') {
      const label = textNode('label', 'bp20-select-label', firstLabel);
      const select = document.createElement('select');
      select.className = 'bp20-select';
      select.replaceChildren(...firstValues.map((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        return option;
      }));
      select.value = state.first;
      select.addEventListener('change', () => {
        state.first = select.value;
        pruneQuantitiesForCurrentFirst(data, state);
        syncUiToSelectedVariant(state, data, firstVariantForFirstValue(data, state.first));
        renderMatrix(mount, data, state, parts);
      });
      control.replaceChildren(label, select);
      renderMatrix(mount, data, state, parts);
    } else {
      const group = document.createElement('div');
      group.className = 'bp20-tabs';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', firstLabel);
      firstValues.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bp20-tab';
        button.textContent = value;
        button.addEventListener('click', () => {
          state.first = value;
          pruneQuantitiesForCurrentFirst(data, state);
          syncUiToSelectedVariant(state, data, firstVariantForFirstValue(data, state.first));
          group.querySelectorAll('.bp20-tab').forEach((node) => node.classList.toggle('is-active', node === button));
          renderMatrix(mount, data, state, parts);
        });
        if (value === state.first) button.classList.add('is-active');
        group.append(button);
      });
      control.replaceChildren(group);
      renderMatrix(mount, data, state, parts);
    }
    return true;
  }


  function unsafePlacementContext(element) {
    return Boolean(element.closest('quick-add-modal, modal-dialog, [id*="Quick"], [class*="quick"]'));
  }

  function placementRoot(mount, data) {
    const root = data?.root || sectionRoot(mount);
    const productInfo = mount.closest('product-info') || root.querySelector('product-info') || root.closest?.('product-info');
    return productInfo || root;
  }

  function relocateMount(mount, data) {
    if (mount.getAttribute('data-bulk-purchase-2-0-placement') === 'purchase-spec-block') return;
    const root = placementRoot(mount, data);
    if (!root || unsafePlacementContext(root)) return;

    const anchor = root.querySelector('variant-selects, variant-radios, [id^="variant-selects-"]');
    const submit = root.querySelector('[id^="ProductSubmitButton-"], product-form, .product-form__buttons');
    const anchorBlock = anchor?.closest('.product__block--variant_picker, [data-block-type="variant_picker"]') || anchor;
    if (anchorBlock?.parentNode) {
      anchorBlock.insertAdjacentElement('afterend', mount);
      mount.setAttribute('data-bulk-purchase-2-0-placement', 'purchase-spec-block');
      mount.setAttribute('data-bulk-purchase-2-0-placement-anchor', anchorBlock === anchor ? anchor.tagName.toLowerCase() : 'variant-picker-block');
      revealMount(mount);
      return;
    }
    if (submit?.parentNode) {
      submit.insertAdjacentElement('beforebegin', mount);
      mount.setAttribute('data-bulk-purchase-2-0-placement', 'purchase-spec-block');
      mount.setAttribute('data-bulk-purchase-2-0-placement-anchor', submit.tagName.toLowerCase());
      revealMount(mount);
    }
  }

  function initialize(root = document) {
    root.querySelectorAll(mountSelector).forEach((mount) => {
      if (mount.getAttribute(initializedAttr) === 'true') return;
      const data = productData(mount);
      if (!data) {
        mount.setAttribute(statusAttr, 'no-product-data');
        return;
      }
      mount.setAttribute(initializedAttr, 'true');
      relocateMount(mount, data);
      const didRender = render(mount, data);
      if (didRender) {
        hideNativeVariantPicker();
        retireResidualMultivariants();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target || document);
  });
})();

/* bp20 unsupported-options native picker fallback 2026-06-25 */

/* bp20 mobile quantity moq refine 2026-06-06 */

/* bp20 moq data bridge refine 2026-06-06 */

/* bp20 native variant sync 2026-06-06 */

/* bp20 ux refine v2 2026-06-06 */

/* bp20 bulk add fastlane 2026-06-06 */

/* bp20 cart linkage refine 2026-06-06 */

/* bp20 selection review refine 2026-06-06 */

/* bp20 estimated total refine 2026-06-06 */

/* bp20 action readiness refine 2026-06-06 */

/* bp20 v3 three-option selector release asset 2026-06-25 */
